import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ObterSobreState } from '../../reducers/Sobre/obter-sobre.reducer';

export const selectObterSobreState = createFeatureSelector<ObterSobreState>('obterSobre');

export const selectDadosObterSobre = createSelector(
  selectObterSobreState,
  (state: ObterSobreState) => state.response
);

export const selectObterSobre = createSelector(
  selectObterSobreState,
  (state: ObterSobreState) => state
);

export const selectErrosObterSobre = createSelector(
  selectObterSobreState,
  (state: ObterSobreState) => state.error
);
